export default {
  SYSTEM: { value: 1, label: "系统消息" },
  COMMENT: { value: 2, label: "评论" },
  LIKE_AND_FAVOR: { value: 3, label: "点赞和收藏" },
  MEMBER_FOLLOW: { value: 4, label: "关注" },
  POST_UP: { value: 5, label: "帖子上架" },
  POST_REMOVED: { value: 6, label: "帖子被删除" },
  POST_EXPIRED: { value: 7, label: "帖子已过期" },
  POST_COMMENT: { value: 8, label: "帖子评论" },
  POST_COMMENT_REPLY: { value: 9, label: "帖子评论回复" },
  COMMENT_REMOVED: { value: 10,label:  "删除评论" },
  COMMENT_UP: { value: 11,label:  "评论上架" }
}
